import React from 'react';

const LicenseInformation: React.FC = () => {
    const licensedTo = import.meta.env.VITE_LICENSED_TO || 'Demo Company';
    const licenseKey = import.meta.env.VITE_LICENSE_KEY || 'License key not available';

    return (
        <div>
            <strong><h2>License Information</h2></strong>
            <p>Licensed to: {licensedTo}</p>
            <p>License Key: {licenseKey}</p>
        </div>
    );
};

export default LicenseInformation;